/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Command } from '../../models/command';

export interface SendCommandPost$Params {
  parkingPlaceId?: number;
  command?: Command;
  parkingSpotId?: number;
}

export function sendCommandPost(http: HttpClient, rootUrl: string, params?: SendCommandPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, sendCommandPost.PATH, 'post');
  if (params) {
    rb.query('parkingPlaceId', params.parkingPlaceId, {});
    rb.query('command', params.command, {});
    rb.query('parkingSpotId', params.parkingSpotId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

sendCommandPost.PATH = '/SendCommand';
